<script>

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    import { onMount } from 'svelte';

    import Media from '@smui/card';
    import LoadingModal from "./LoadingModal.svelte";
    import Messages from "./form/Messages.svelte";
    import Message from "./form/Message.svelte";

    let cls;

    export let show = false;
    export let maxWidth = 700;
    export let width = 400;
    export let id;
    export let headerBackground;
    export let headerHeight = headerBackground ? 200 : 0;
    export let headerBackgroundPosition = "bottom";
    export let style = "";
    //export let loading = false;
    export let loadingModalGlobal = false;

    //
    export let request;

    let height;
    let instance;

    $: calculatedStyle = `
        max-width: ${(width > maxWidth) ? width : maxWidth}px;
        width: ${width}px;
        padding-top: ${headerHeight + 25}px;
        ${style};
    `;

    // TODO: this cannot be a computed property or the header background
    // will flicker on every keystroke
    let calculatedHeaderBackgroundStyle = `
        background-image: url(${headerBackground});
        height: ${headerHeight}px;
        background-position: center ${headerBackgroundPosition};
    `;

    export {cls as class};

    $: hasHeaderBackground = !!headerBackground;
    $: isOffscreen = height && height > window.innerHeight;
</script>

<!-- TODO: support layout specification -->
<!-- TODO: support passing description by slot -->
<div bind:this={instance} bind:clientHeight={height} class="dialog {cls}" class:show class:hasHeaderBackground {id} style={calculatedStyle}>
    {#if headerBackground}
        <Media
            class="card-media-16x9 dialog-header-background"
            aspectRatio="16x9"
            style={calculatedHeaderBackgroundStyle}
        />
    {/if}

    <h2><slot name="title"></slot></h2>

    <Messages>
        <Message><slot name="messages"></slot></Message>
    </Messages>

    <slot>
        <!-- contents will yield here -->
    </slot>

    {#if request}
        {#await request}
            <LoadingModal global={loadingModalGlobal}/>
        {/await}
    {/if}
</div>

<style>

    .dialog {
        //text-align: center;
        background: white;
        border-radius: 15px;
        //max-width: 400px;
        padding: 50px;
        //-webkit-box-shadow: -2px -2px 28px 18px rgba(0,0,0,0.12);
        //-moz-box-shadow: -2px -2px 28px 18px rgba(0,0,0,0.12);
        //box-shadow: -2px -2px 28px 18px rgba(0,0,0,0.12);

        /* https://tobiasahlin.com/blog/layered-smooth-box-shadows/ */
        box-shadow: 0 1px 1px rgba(0,0,0,0.12),
                      0 2px 2px rgba(0,0,0,0.12),
                      0 4px 4px rgba(0,0,0,0.12),
                      0 8px 8px rgba(0,0,0,0.12),
                      0 16px 16px rgba(0,0,0,0.12);

        opacity: 1;
        //transition: all 0.75s;
        position: relative;
        top: 0;
        overflow: hidden;
        //box-sizing: border-box;
    }

    .dialog.hasHeaderBackground {
        padding-top: 225px;
    }

    :global(.dialog.hasHeaderBackground .dialog-header-background) {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        //height: 200px;
        background-size: cover;
        background-position: center bottom;
    }

    .dialog:not(.show) {
        opacity: 0;
        pointer-events: none;
        top: -200px;
        position: absolute;
    }

    :global(.dialog h1, .dialog h2) {
        text-align: center;
    }

    .dialog p {
        margin: 0;
        margin-bottom: 25px;
    }
</style>